export const namespaced = true
import BaseStore from '@/store/baseDikeTrajectoryStore'

const baseURI = '/dike_sections/'

const baseStore = new BaseStore(baseURI)

const getDefaultState = () => {
  return {
    ...baseStore.state,
    status: 'empty',
    firstLoad: true,
    bounds: null
  }
}

export const state = getDefaultState()

export const mutations = {
  ...baseStore.mutations,
  resetState(state) {
    Object.assign(state, getDefaultState())
  },
  SET_FIRST_LOAD(state) {
    state.firstLoad = false
  }
}
export const actions = {
  ...baseStore.actions,
  resetState(context) {
    context.dispatch('referencePoint/resetState', null, { root: true })
    context.dispatch('dikeProfiles/resetState', null, { root: true })
    context.commit('resetState')
  },
  setCurrentItem(context, payload) {
    if (context.rootState.dikeProfiles.loadingElevation) {
      return
    }
    context.commit('SET_CURRENT_ITEM', payload)
    context.dispatch('dikeProfiles/checkCurrentItem', null, { root: true })
  },
  async checkCurrentItem(context) {
    let dikeSectionId = context.rootState.dikeProfiles.currentItem?.properties.dikesection_id
    if (!context.state.currentItem || context.state.currentItem.id !== dikeSectionId) {
      let currentItem = context.state.items.features.find((item) => item.id === dikeSectionId)
      context.commit('SET_CURRENT_ITEM', currentItem)
    }
  },
  setFirstLoad({ commit }) {
    commit('SET_FIRST_LOAD')
  }
}

export const getters = {
  getDikeSectionFromEvent: (state, getters) => (e) => {
    let dikeSectionId = e.features[0].properties['geometry_id'] // Required to get the correctId
    return getters.getDikeSectionFromId(dikeSectionId)
  },
  getDikeSectionFromId: (state) => (id) => {
    return state.items ? state.items.features.find((dikeSection) => dikeSection.id === id) : null
  },
  getDikeSectionId: (state) => {
    return state.currentItem ? state.currentItem.id : null
  },
  leafletItems: (state) => {
    if (!state.items?.features) {
      return null
    }
    const features = JSON.parse(JSON.stringify(state.items.features))
    features?.forEach((feature) => {
      if (feature.geometry && feature.geometry.coordinates) {
        feature.geometry.coordinates.forEach((coord) => {
          if (Array.isArray(coord) && coord.length >= 2) {
            // Swap the values at index 0 and index 1
            ;[coord[0], coord[1]] = [coord[1], coord[0]]
          }
        })
      }
    })
    return features
  },
  boundItems: (state) => {
    const features = state.items?.features
    let minX = Infinity
    let minY = Infinity
    let maxX = -Infinity
    let maxY = -Infinity
    features?.forEach((feature) => {
      if (feature.geometry && feature.geometry.coordinates) {
        feature.geometry.coordinates.forEach((coord) => {
          if (Array.isArray(coord) && coord.length === 2) {
            minX = Math.min(minX, coord[0])
            minY = Math.min(minY, coord[1])
            maxX = Math.max(maxX, coord[0])
            maxY = Math.max(maxY, coord[1])
          }
        })
      }
    })
    return [
      [minY, minX],
      [maxY, maxX]
    ]
  }
}
